import React, { useEffect, useState } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import Swal from "sweetalert2";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { formatCNPJ } from "../../Services/formatCNPJ";

export default function VincularUsuarioProcesso() {
  const [usuarios, setUsuarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [processos, setProcessos] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [processosSelecionados, setProcessosSelecionados] = useState([]);
  const [filtroUsuarios, setFiltroUsuarios] = useState("");
  const [filtroClientes, setFiltroClientes] = useState("");
  const [filtroProcessos, setFiltroProcessos] = useState("");

  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();

  const navigate = useNavigate();
  let idFormatado = String(IDOperador).padStart(6, '0');


  useEffect(() => {
    if (!operador && !authReady) {
      navigate("/");
    }
  }, [operador]);

  useEffect(() => {
    // Carregar usuários ao iniciar
    carregarOperadores();
  }, []);

  const usuariosFiltrados = usuarios.filter((u) =>
    `${String(u.IDOperador).padStart(6, '0')} - ${u.nome}`
      .toLowerCase()
      .includes(filtroUsuarios.toLowerCase())
  );

  const clientesFiltrados = clientes.filter((c) =>
    `${c.nome} - ${formatCNPJ(c.cnpj)}`.toLowerCase().includes(filtroClientes.toLowerCase())
  );

  const processosFiltrados = processos.filter((p) =>
    p.descricao.toLowerCase().includes(filtroProcessos.toLowerCase())
  );


  const carregarOperadores = async () => {
    try {
      const res = await api.get("/operadores");
      setUsuarios(res.data);
    } catch (err) {
      console.error("Erro ao carregar operadores", err);
    }
  };

  const carregarClientes = async () => {
    try {
      const res = await api.get("/clientes");
      setClientes(res.data);
    } catch (err) {
      console.error("Erro ao carregar operadores", err);
    }
  };

  useEffect(() => {
    if (usuarioSelecionado !== null) {
      setClienteSelecionado(null);
      carregarClientes();
      setProcessos([]);
    } else {
      setClientes([]);
      setClienteSelecionado(null);
      setProcessos([]);
    }
  }, [usuarioSelecionado]);

  useEffect(() => {
    if (clienteSelecionado !== null) {
      carregarProcessos(clienteSelecionado);
    } else {
      setProcessos([]);
    }
  }, [clienteSelecionado]);


  const carregarProcessos = async (idcliente) => {
    try {
      const res = await api.get(`/processo/cliente/${idcliente}`);
      const listaProcessos = res.data;

      // Buscando processos já vinculados ao operador + cliente
      if (usuarioSelecionado !== null) {
        const resVinculados = await api.get(`/processo/operadorcliente/${usuarioSelecionado}/${idcliente}`);
        const processosVinculados = resVinculados.data;

        // Extrair os IDs dos processos vinculados
        const idsVinculados = processosVinculados.map(p => p.IDProcesso);

        setProcessos(listaProcessos);
        setProcessosSelecionados(idsVinculados);
      } else {
        setProcessos(listaProcessos);
        setProcessosSelecionados([]);
      }
    } catch (err) {
      console.error("Erro ao carregar processos", err);
    }
  };


  const handleProcessoChange = (processoId) => {
    setProcessosSelecionados((prev) =>
      prev.includes(processoId)
        ? prev.filter((id) => id !== processoId)
        : [...prev, processoId]
    );
  };

  const handleSalvar = async () => {
    if (!usuarioSelecionado) {
      //alert("Selecione um usuário.");
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        text: "Selecione um usuário.",
      });
      return;
    }

    try {
      // 1. Deletar vínculos anteriores
      await api.delete(`/processo/operadorcliente/${usuarioSelecionado}/${clienteSelecionado}`);

      // 2. Criar os novos vínculos (um a um)
      for (const idProcesso of processosSelecionados) {
        await api.post("/processo/operador", {
          IDOperador: usuarioSelecionado,
          IDProcesso: idProcesso,
        });
      }

      //alert("Vinculação salva com sucesso!");
      Swal.fire({
        icon: "success",
        title: "Operação concluída",
        text: "Vínculação salva com sucesso!",
      });

      // 3. Resetar os estados
      setClienteSelecionado(null);
      setProcessos([]);
      setProcessosSelecionados([]);
      setClientes([]); // limpa lista de clientes
      setUsuarioSelecionado(null); // opcional, se quiser resetar também

      // Recarregar usuários
      carregarOperadores();

    } catch (err) {
      console.error("Erro ao salvar vinculação", err);
      //alert("Erro ao salvar vinculação.");
      Swal.fire({
        icon: "error",
        title: "Atenção!",
        text: "Houve uma falha ao salvar a vinculação.",
      });
    }
  };

  // function formatCNPJ(cnpj) {
  //   cnpj = cnpj.replace(/\D/g, '');
  //   if (cnpj.length !== 14) return cnpj;
  //   return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  // }

  return (

    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />
        <div className="container">
          <h2>Permissão de Operadores</h2>
          <div className="grid">
            <div className="column">
              <h3>Usuários</h3>
              {usuarios.length > 0 && (
                <input
                  type="text"
                  placeholder="Filtrar usuários..."
                  value={filtroUsuarios}
                  onChange={(e) => setFiltroUsuarios(e.target.value)}
                  onBlur={() => setTimeout(() => setFiltroUsuarios(""), 300)}
                  className={`input-filtro ${usuariosFiltrados.length > 0 ? "show" : ""}`}
                />
              )}
              <ul>
                {usuariosFiltrados.map((u) => (
                  <li key={u.IDOperador}
                    className={usuarioSelecionado === u.IDOperador ? "itemSelecionado" : ""}>
                    <label>
                      <input
                        type="radio"
                        name="usuario"
                        checked={usuarioSelecionado === u.IDOperador}
                        onChange={() => setUsuarioSelecionado(u.IDOperador)}
                      />
                      {String(u.IDOperador).padStart(6, '0') + ' - ' + u.nome}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            <div className="column">
              <h3>Clientes</h3>
              {clientes.length > 0 && (
                <input
                  type="text"
                  placeholder="Filtrar clientes..."
                  value={filtroClientes}
                  onChange={(e) => setFiltroClientes(e.target.value)}
                  className={`input-filtro ${clientesFiltrados.length > 0 ? "show" : ""}`}
                />
              )}
              <ul>
                {clientesFiltrados.map((c) => (
                  <li key={c.IDCliente}
                    className={clienteSelecionado === c.IDCliente ? "itemSelecionado" : ""}>
                    <label>
                      <input
                        type="radio"
                        name="cliente"
                        checked={clienteSelecionado === c.IDCliente}
                        onChange={() => setClienteSelecionado(c.IDCliente)}
                      />
                      {c.nome + ' - ' + formatCNPJ(c.cnpj)}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            <div className="column">
              <h3>Processos</h3>
              {processosFiltrados.length > 0 && (
                <input
                  type="text"
                  placeholder="Filtrar processos..."
                  value={filtroProcessos}
                  onChange={(e) => setFiltroProcessos(e.target.value)}
                  className={`input-filtro ${processosFiltrados.length > 0 ? "show" : ""}`}
                />
              )}
              <ul>
                {processosFiltrados.map((p) => (
                  <li key={p.IDProcesso}>
                    <label>
                      <input
                        type="checkbox"
                        checked={processosSelecionados.includes(p.IDProcesso)}
                        onChange={() => handleProcessoChange(p.IDProcesso)}
                      />
                      {p.descricao}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <button onClick={handleSalvar} className="btn-salvar">Salvar</button>
        </div>

      </div>
    </div>
  );
}
